import { render, staticRenderFns } from "./MainFacts.vue?vue&type=template&id=0d1d9452&scoped=true&"
import script from "./MainFacts.vue?vue&type=script&lang=js&"
export * from "./MainFacts.vue?vue&type=script&lang=js&"
import style0 from "./MainFacts.vue?vue&type=style&index=0&id=0d1d9452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1d9452",
  null
  
)

export default component.exports